export const TAX_RULES_UNIVERSAL_URL = '/e/tax_rules?variant=a'
export const CHECK_STATUS_URL = '/e/taxpayer_center'
